<div class="menu-btns">
	@for (item of items(); track trackByItem($index, item)) {
		<span
			[matTooltip]="item.tooltip || ''"
			[matTooltipDisabled]="!item.tooltip"
			[matTooltipPosition]="tooltipPosition()"
		>
			<lvr-button
				variant="primary"
				[label]="item.label"
				[ariaLabel]="item.ariaLabel || item.label"
				[type]="'button'"
				[disabled]="item.disabled ?? false"
				(clicked)="onItemClick(item, $event)"
				[loading]="item.showLoading ?? false"
				[loadingLabel]="item.loadingLabel ?? '' | transloco"
				[icon]="item.icon ?? null"
			></lvr-button>
		</span>
	}
</div>
